@if (!hideWishlist()) {
  <sd-product-wishlist-button [productCode]="productCode()"></sd-product-wishlist-button>
}
<sd-product-comparison-button [productCode]="productCode()"></sd-product-comparison-button>
